/**
 * Google Integration Types
 */

export interface GoogleAccount {
    id: number;
    email: string;
    service: string;
    scopes: string[];
    expires_at: string | null;
    created_at: string | null;
}

export interface GoogleAuthResponse {
    message: string;
    email: string;
    service: string;
}

export interface GoogleService {
    name: string;
    displayName: string;
    description: string;
    icon: string;
    scopes: string[];
}

export const GOOGLE_SERVICES: GoogleService[] = [
    {
        name: 'gmail',
        displayName: 'Gmail',
        description: 'Read emails and manage your inbox',
        icon: '📧',
        scopes: [
            'https://www.googleapis.com/auth/gmail.readonly',
            'https://www.googleapis.com/auth/userinfo.email',
            'openid'
        ]
    },
    {
        name: 'calendar',
        displayName: 'Google Calendar',
        description: 'Read and manage your calendar events',
        icon: '📅',
        scopes: [
            'https://www.googleapis.com/auth/calendar.events',
            'https://www.googleapis.com/auth/userinfo.email',
            'openid'
        ]
    }
];

export interface GoogleIntegrationState {
    accounts: GoogleAccount[];
    loading: boolean;
    error: string | null;
}
